import React, { useState, useEffect } from 'react';

export default function BotAutomationPage() {
  const getStudioUrl = () => {
    if (process.env.REACT_APP_CLOUD_AI_URL) return process.env.REACT_APP_CLOUD_AI_URL;
    if (typeof window !== 'undefined' && window.location) {
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        return `${window.location.protocol}//${window.location.hostname}:3005`;
      }
      return `${window.location.origin}/cloud-ai/`;
    }
    return 'https://telegrambot.in/cloud-ai/';
  };

  const [studioUrl, setStudioUrl] = useState(getStudioUrl);

  useEffect(() => {
    setStudioUrl(getStudioUrl());
  }, []);

  return (
    <div className="w-full h-full flex flex-col min-h-0 flex-1 overflow-hidden bg-[#092c30]" data-testid="bot-automation-studio">
      <iframe
        src={studioUrl}
        title="Telegram Bot Visual Workflow Studio"
        className="w-full h-full flex-1 border-none min-h-0"
        allow="clipboard-read; clipboard-write; microphone; camera"
      />
    </div>
  );
}